import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { inject } from '@app/providers/QAU.ContextProvider';
import useIntlMessage from '@app/hooks/use-intl-message';
import { fetchProductData } from '@app/actions/artworkDataActions';

import { startLoading, endLoading } from '@app/actions/spinnerActions';
import './ErrorModeView.scss';

const ErrorModeView = ({
  flowConfig,
  startLoading,
  endLoading,
  errorCode,
  productData,
  fetchProductData,
  productId,
  deploymentId,
  consumer,
}) => {
  const [trimLineNotSupported, artworkUploadNotSupported] = useIntlMessage('qau-error-476', 'qau-error-481');

  const errorMessageMap = {
    476: trimLineNotSupported,
    481: artworkUploadNotSupported,
  }

  const prepareRedirectURL = (productData) => {
      const apiUrl = flowConfig.getResourceURL('dpo8-design-with-quote-api');
      const method = flowConfig.getResourceMethod('dpo8-design-with-quote-api');

      const { sku, productGroupName } = productData;

      const redirectURL = `${apiUrl}?deploymentId=${deploymentId}&sku=${sku}&consumer=${consumer}&source=UploadDesign&productGroupName=${productGroupName}`;
      return {
        redirectURL,
        method,
      }
  };

  const prepareCrossDocumentMessage = (productData, errorCode) => {
    const localizedErrorMessage = errorMessageMap[errorCode];
    const { redirectURL, method } = prepareRedirectURL(productData);
    const error = { code: errorCode, message: localizedErrorMessage };

    return {
      redirectURL,
      method,
      errors: [ error ],
    };
  };

useEffect(() => {
  if (!productData || !errorCode) return;
    const crossDocumentMessage = prepareCrossDocumentMessage(productData, errorCode);

    window.top.postMessage(crossDocumentMessage, '*');
    window.close();
},[productData, errorCode]);

useEffect(() => {
  startLoading();
  fetchProductData(productId);
  return () => {
    endLoading();
  };
}, [fetchProductData, productId, startLoading, endLoading]);

  return (
    <div id="qau-error-mode-view">
    </div>
  );
};

const mapStateToProps = ({ matrix, artwork }
) => {
  const { target: { name: deploymentId }, ctx: { errorCode, consumer }, design: { product: productId }} = matrix;
  const { product: productData } = artwork;
  return {
    errorCode,
    productId,
    productData,
    deploymentId,
    consumer,
  };
};

const mapDispatchToProps = {
  startLoading,
  endLoading,
  fetchProductData,
};

ErrorModeView.propTypes = {
  deploymentId: PropTypes.string.isRequired,
  consumer: PropTypes.string.isRequired,
  errorCode: PropTypes.string.isRequired,
  productId: PropTypes.string.isRequired,
  productData: PropTypes.object,
  flowConfig: PropTypes.object.isRequired,
  fetchProductData: PropTypes.func.isRequired,
};

export default inject('flowConfig')(connect(mapStateToProps, mapDispatchToProps)(ErrorModeView));
